import {AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {CurrencyTransformPipe} from "../../../pipes/currency-transform.pipe";

@Component({
    selector: 'app-simple-bar-chart',
    templateUrl: './simple-bar-chart.component.html',
    styleUrls: ['./simple-bar-chart.component.css'],
    providers: [CurrencyTransformPipe]
})
export class SimpleBarChartComponent implements OnInit, AfterViewInit {

    @ViewChild('wrapper')
    public wrapper: ElementRef;

    @ViewChild('canvas')
    public canvas: ElementRef;

    @Input('rightLabel')
    public rightLabel = true;

    @Input('barLabel')
    public barLabel = true;

    @Input('showPercentValue')
    public showPercentValue = true;

    @Input('width')
    public width = 400;

    @Input('height')
    public height = 400;

    @Input('barWidth')
    public barWidth = -1;

    @Input('chartData')
    public chartData = [
        {
            title: 'First One',
            value: 23,
            color: '#fff',
            postfix: "usd"
        },
        {
            title: 'Second One',
            value: 10,
            color: '#fff',
            postfix: "usd"

        },
    ];

    private cx: CanvasRenderingContext2D;

    constructor(private currencyPipe: CurrencyTransformPipe) {
    }

    ngOnInit() {
        if (this.barWidth === -1) {
            this.barWidth = this.width / 2;
        }
    }

    /**
     * This is where the magic happening :D (drawing the chart)
     */
    ngAfterViewInit() {

        const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
        this.cx = canvasEl.getContext('2d');

        canvasEl.width = this.wrapper.nativeElement.offsetWidth;
        canvasEl.height = this.height;

        let firstValue = this.chartData[0]['value'];
        let secondValue = this.chartData[1]['value'];

        let firstTransformedValue = this.currencyPipe.transform(firstValue, this.chartData[0].postfix);
        let secondTransformedValue = this.currencyPipe.transform(secondValue, this.chartData[1].postfix);

        const firstHeight = this.height;
        const secondHeight = ((100 * secondValue) / firstValue) / 100 * firstHeight;

        const total = this.chartData[0]['value'] + this.chartData[1]['value'];
        const firstPercentage = Number((this.chartData[0]['value'] * 100) / total).toFixed(2);
        const secondPercentage = Number((this.chartData[1]['value'] * 100) / total).toFixed(2);

        let startY = 0;

        this.cx.fillStyle = '#96A2A6';
        this.cx.fillRect(this.barWidth + 10, startY, this.barWidth - 10, firstHeight);

        // if (firstHeight - secondHeight > 30) {
        this.cx.fillStyle = 'white';
        this.cx.textAlign = 'center';
        const firstTextSize = firstHeight - secondHeight > 25 ? 25 : (firstHeight - secondHeight) / 2;
        this.cx.font = firstTextSize + 'px Arial';

        this.cx.fillText(firstTransformedValue, 230, ((firstHeight - secondHeight) / 2) + firstTextSize / 3, this.barWidth - 30);

        // }

        startY += firstHeight - secondHeight;

        this.cx.fillStyle = '#C1D0D5';
        this.cx.fillRect(this.barWidth + 15, startY, this.barWidth - 20, secondHeight);

        this.cx.fillStyle = 'white';
        this.cx.fillText(secondTransformedValue, 230, ((secondHeight) / 2) + startY, this.barWidth - 30);


        // const chartValuesData = this.generatePercentageData();
        //
        // let currentPosition = 0;
        //
        //
        // for (const data of chartValuesData) {
        //     this.cx.fillStyle = data.color;
        //     this.cx.fillRect(10, currentPosition, this.barWidth, data.height);
        //
        //     this.cx.fillStyle = 'white';
        //
        //     let textSize = 25;
        //
        //     if (data.height < 25) {
        //         textSize = data.height;
        //     }
        //
        //     this.cx.font = textSize + 'px Arial';
        //
        //     const distanceFromTop = currentPosition + ((data.height / 2) + (textSize / 3));
        //
        //     if (this.barLabel) {
        //         this.cx.textAlign = 'center';
        //         if (this.showPercentValue) {
        //             this.cx.fillText(data.percentage + '%', (this.barWidth / 2) + 10, distanceFromTop, this.barWidth - 10);
        //         } else {
        //             this.cx.fillText(this.currencyPipe.transform(data.value, data.postfix), (this.barWidth / 2) + 10, distanceFromTop, this.barWidth - 10);
        //
        //         }
        //     }
        //
        //     if (this.rightLabel) {
        //         this.cx.fillStyle = 'grey';
        //         this.cx.textAlign = 'left';
        //         this.cx.fillText(data.text, this.barWidth + 20, distanceFromTop, this.width - this.barWidth - 30);
        //     }
        //
        //     currentPosition += data.height;
        // }

    }

    /**
     * This function is used to generate data dinamically based on the input values (@chartData)
     * @returns {Array<any>}
     */
    private generatePercentageData(): Array<any> {
        const data = [];

        let totalNumber = 0;

        for (const values of this.chartData) {
            totalNumber += values.value;
        }

        for (const values of this.chartData) {

            const percent = (values.value * 100) / totalNumber;
            const chartHeight = this.height * (percent / 100);

            data.push({
                value: values.value,
                color: 'rgba(' + values.color + ", " + (percent * 2) / 100 + ")",
                postfix: values.postfix,
                percentage: Number(percent).toFixed(2),
                height: chartHeight,
                text: values.title
            });
        }


        return data;
    }

}



// WEBPACK FOOTER //
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/components/charts/simple-bar-chart/simple-bar-chart.component.ts